<template>
  <block-item-card
    :min-height="minBlockHeight"
    class="gradient-grey-06-bg"
    style="padding: 20px !important;"
  >
    <v-row class="header-row">
      <img
        src="/img/dashboard/market_data_icon.svg"
        alt="Market Data Icon"
        class="svg-icon"
      >

      <span
        class="header-row-text"
      >{{ $t('Dashboard.Banking.MarketData.Title') }}</span>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        class="px-0"
      >
        <live-alerts />
      </v-col>
      <v-col
        cols="6"
        class="px-0 mt-3"
      >
        <live-prices-block
          :has-border="false"
          :title-size="12"
          :override-title-size="true"
          :title-icon="'true'"
          :title-margin-top="'4px'"
        />
      </v-col>
      <v-col
        cols="6"
      >
        <hedging-positions />
      </v-col>
    </v-row>
  </block-item-card>
</template>

<script>

import routerTabState        from '@/mixins/routerTabState'
import BlockItemCard from '@/theme/default/components/common/BlockItemCard.vue'
import LiveAlerts from '@/theme/default/views/banking/dashboard/market-data/LiveAlerts.vue'
import HedgingPositions from '@/theme/default/views/banking/dashboard/market-data/HedgingPositions.vue'
import LivePricesBlock                   from '@/theme/default/views/dashboard/blocks/LivePricesBlock'

export default {
  name      : 'MarketData',
  components: {
    BlockItemCard,
    LiveAlerts,
    HedgingPositions,
    LivePricesBlock
  },
  directives: {},
  mixins    : [routerTabState],
  dataStore : {
    niiAnalysisData: 'NII.FindNIIAnalysis'
  },
  enums    : {},
  dataModel: null,
  data () {
    return {
      minBlockHeight: 500
    }
  },
  computed: {
  },
  methods: {}
}
</script>

<style scoped>
.header-row {
  font-family: Inter, Aeonik, Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #607D8B;
  padding-left: 13px;
  padding-top: 10px;
  display: flex;
  align-items: center;
}

.header-row-text {
  padding-left: 4px;
  color: #607D8B;
}

.icon-container {
  background-color: #607D8B;
  border-radius: 6px;
  width: 40px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
}

.svg-icon {
  /* width: 28px;
  height: 18px; */
  display: block;
}

</style>
